import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { SessionContext } from "../../common/SessionContext";

const scrollTop = () =>
  window.scrollTo({ top: 0, behavior: "smooth" });

function ThanksWrapperArea(props) {

  const { session } = useContext(SessionContext);
  const currentCurrency = session.currency;

  // API configuration constants
  const API_URL = "https://test.campfr.com/api/get_booking/" + props.ctype + "/" + props.hash;
  const API_TOKEN = process.env.REACT_APP_API_TOKEN;

  // State management for booking data, loading status, and error handling
  const [booking, setBooking] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch booking data on mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(API_URL, {
          headers: { "X-API-TOKEN": API_TOKEN }
        });
        console.log("Booking:", response.data);
        setBooking(response.data);
        setLoading(false);
      } catch (err) {
        console.error("API Error:", err);
        setError(err.message || "Failed to fetch API");
        setLoading(false);
      }
    };

    fetchData();
  }, []); // runs once on mount



  return (
    <div className="contact-wrapper pt-110">
      <div className="container">
        <div className="row align-items-center justify-content-lg-center gy-5">
          <div className="col-lg-6">
            <div className="contatc-intro-figure">
              <img
                src={`${process.env.PUBLIC_URL}/images/banner/booked-bg.png`}
                alt="ContactBannerIMG"
                className="img-fluid"
              />
            </div>
          </div>
          <div className="col-lg-5">
            <div className="booked-info">
              <h3>All done!</h3>
              <div className="">
                <ul className="slider-container">
                  <li>
                    <p>You're going to CAMP! We've sent an email to <span className="sent_email">{booking.email}</span> with confirmation of your booking, and links to the CAMP Hub, where you can manage your booking and get all the info you need. If you don't receive the mail for some reason (and it's not in your spam folder) drop us a line at <a href="mailto:hello@campfr.com">hello@campfr.com</a></p>
                    <p>We look forward to welcoming you to CAMP!</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ThanksWrapperArea;
